{
  "Empty": "ריק"
}
